// extracted by mini-css-extract-plugin
export default {"priorityDiv":"ListItems_priorityDiv__Hnzqe"};